var render = function render(_c,_vm){return _c('section',{staticClass:"c-highlight c-highlight--detail"},[_c('div',{staticClass:"o-container u-py-25"},[_c('div',{staticClass:"o-row"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }